module.exports = __webpack_public_path__ + "static/media/create-password.08a77854.jpg";